import basicRequest from "../../../core/redux/actions/request";
import { notification } from "antd";

const PREFIX = "CACHE_CLIENT";
const getState = (state) => state.cache.client;

/**
 * BASIC REQUEST
 */
const {
    reset: resetCacheClient,

    getCachePattern,

    isLoaded: isCacheClientLoaded,
    isLoading: isCacheClientLoading,
    getError: getCacheClientError,
    getData,
} = basicRequest(PREFIX, getState);

/**
 * Load Cache from API
 */
export const loadCacheClient = () => getCachePattern("cache/v1/clients", {});

/**
 * Selectors for RAW data
 */
const getClients = (state) => (isCacheClientLoaded(state) ? getData(state).clients : []);
const getProjects = (state) => (isCacheClientLoaded(state) ? getData(state).projects || [] : []);
const getPointsOfSale = (state) => (isCacheClientLoaded(state) ? getData(state).points_of_sale || [] : []);
const getComponents = (state) => (isCacheClientLoaded(state) ? getData(state).components || [] : []);

/**
 * Generic function to create an array indexed by id
 *
 * TODO:
 *    - Should be a function ? ( errores when ids outside of its domain )
 *    - Should be in the reducer ?
 */
const getById = (list) => {
    return list.reduce((acc, cur) => ({ ...acc, [cur.id]: cur }), {});
};

/**
 * Selectors for display data for a specific ID
 */
export const getClientsById = (state) => getById(getClients(state));
export const getProjectsById = (state) => getById(getProjects(state));
export const getPointsOfSaleById = (state) => getById(getPointsOfSale(state));
export const getComponentsById = (state) => getById(getComponents(state));

export const getClientsForSelect = (state) => {
    const list = getClients(state).filter((item) => item.active);
    return (list || []).map((item) => {
        return { ...item, value: item.id, label: item.name, active: item.active.toString() };
    });
};

export const getProjectsForSelect = (state) => {
    const list = getProjects(state).filter((item) => item.active);
    return (list || []).map((item) => {
        return { ...item, value: item.id, label: item.name, active: item.active.toString() };
    });
};

export const getProjectsWithOptForSelect = (state) => {
    const projects = getProjectsForSelect(state);
    return getClientsForSelect(state).map((item) => {
        const { value, ...rest } = item;

        const options = projects
            .filter((item) => item.active && item.client_fk && item.client_fk.id == value)
            .map((item) => {
                return { ...item, value: item.id, label: item.name, active: item.active.toString() };
            });

        return { ...rest, options: options };
    });
};

export const getPointsOfSaleForSelect = (state) => {
    const list = getPointsOfSale(state).filter((item) => item.active);
    return (list || []).map((item) => {
        return { ...item, value: item.id, label: item.name, active: item.active.toString() };
    });
};

export const getPointsOfSaleWithOptForSelect = (state) => {
    const clients = getClients(state).filter((item) => item.active);
    const pointsOfSale = getPointsOfSaleForSelect(state);

    return getProjectsForSelect(state)
        .map((item) => {
            const { value, client_fk, ...rest } = item;

            const client = clients.find((item) => item.id === client_fk?.id);
            const label = client && client.name ? `${client.name} > ${item.label}` : `${item.label}`;

            const options = pointsOfSale
                .filter((item) => item.active && item.project_fk && item.project_fk.id == value)
                .map((item) => {
                    return { ...item, value: item.id, label: item.name, active: item.active.toString() };
                });

            return { ...rest, options: options, label: label };
        })
        .filter((item) => (item.options || []).length > 0);
};

export const getComponentsForSelect = (state) => {
    const list = getComponents(state).filter((item) => item.active);
    return (list || []).map((item) => {
        return { ...item, value: item.id, label: item.name, active: item.active.toString() };
    });
};

/**
 * Private function to trigger a reset in the cache and display a message
 */
const onChangeSuccessfully = (message) => (dispatch) => {
    notification.success(message);
    dispatch(resetCacheClient());
};

/**
 * Public interfaces for request an update in the cache
 */
export const onChangeInClients = onChangeSuccessfully;

export { isCacheClientLoaded, isCacheClientLoading, getCacheClientError };
